import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const Forbidden = () => {
	const { t } = useTranslation();

	return (
		<Container className="mt-5">
			<Row className="justify-content-center">
				<Col md="8" lg="6">
					<Card>
						<CardBody className="text-center">
							<h1 className="display-4">403</h1>
							<h4>{t('forbidden.title')}</h4>
							<p className="text-muted">{t('forbidden.message')}</p>
							<Button color="primary" tag={Link} to="/dashboard" className="mr-2 me-2">
								{t('forbidden.dashboard')}
							</Button>
							<Button color="secondary" tag={Link} to="/Logout">
								{t('forbidden.login')}
							</Button>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Container>
	);
};

export default Forbidden;
